import { render, staticRenderFns } from "./otherSideTablec.vue?vue&type=template&id=0d728bc4&scoped=true"
import script from "./otherSideTablec.vue?vue&type=script&lang=js"
export * from "./otherSideTablec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d728bc4",
  null
  
)

export default component.exports